import React from 'react';

const SubscriptionSuccess = () => {
  return (
    <div className='create-profile-container px-0'>
      <div className='scroll-container h-100 create-profile-general-content'>
        <h2 className='company-name'>Policy Mogul</h2>
        <div className='d-flex justify-content-center align-items-center w-100 py-lg-2 py-lg-5 pt-5'>
          <div className='mt-5 mt-lg-0'>
            <div className='px-5 py-4 create-profile-content'>
              <div className='pt-5 mt-5 create-profile-awaits'>
                <h2 style={{ fontSize: '1.8em' }}>Thank you for your subscription</h2>
                <p>Please check your email for log in details</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
